import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../store/store';

interface BackToStorefrontProps {
  variant?: 'link' | 'button';
  className?: string;
  navigateTo?: string;
  text?: string;
}

export default function BackToStorefront({
  variant = 'link',
  className = '',
  text = 'Back to storefront',
  navigateTo = '/',
}: BackToStorefrontProps) {
  const navigate = useNavigate();
  const { routesPrefix } = useSelector((state: RootState) => state.setup);
  return (
    <>
      {variant === 'button' ? (
        <button
          onClick={() => navigate(routesPrefix + navigateTo)}
          className={`w-full font-dmsans text-sm text-secondary-500 border border-secondary-500 bg-white hover:bg-secondary-50 shadow-sm ${className}`}
        >
          {text}
        </button>
      ) : (
        <p
          className={`mt-4 text-center font-dmsans text-[12px] text-gray-400 ${className}`}
        >
          <span
            className="cursor-pointer hover:text-gray-600 hover:underline transition-colors"
            onClick={() => navigate(routesPrefix + navigateTo)}
          >
            ← {text}
          </span>
        </p>
      )}
    </>
  );
}
